export type BuildTarget = "public" | "admin";

export type ReleaseVersionData = {
  releaseId?: string;
  commitSha?: string;
  buildTarget?: BuildTarget;
  builtAt?: string;
  version?: string;
  timestamp?: number;
};

export const CURRENT_APP_RELEASE_ID = __APP_RELEASE_ID__;
export const CURRENT_APP_BUILD_TARGET = __APP_BUILD_TARGET__;

export const getReleaseIdFromVersionData = (data: ReleaseVersionData | null | undefined) =>
  data?.releaseId ?? data?.version ?? null;
